<template>
  <div class="f1-step" :class="{ active: active }" :style="{ width }">
    <div class="f1-step-icon" @click="$emit('click')">
      <i :class="step.icon" />
    </div>

    <p>{{ step.title }}</p>
  </div>
</template>

<script>
// @vuese
// Zakładka kreatora
// @group Wizard
export default {
  name: 'WizardStep',
  props: {
    // Krok
    step: {
      type: Object,
      required: true
    },
    // Czy aktywny
    active: {
      type: Boolean,
      default: false
    },
    // Szerokość jednego kroku
    width: {
      type: [Number, String],
      required: true
    }
  }
};
</script>

<style>
.f1-step-icon {
  cursor: pointer;
}
</style>
